import { useMount } from 'react-use'

import { useLogEvent } from '~/hooks/useLogEvent'

export const useLogEventOnMount = (
  ...args: Parameters<ReturnType<typeof useLogEvent>>
) => {
  const logEvent = useLogEvent()

  useMount(() => {
    logEvent(...args)
  })
}
